import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { AddNewStakeholderButton, StakeholdersTable } from './stakeholders';
import { AddNewUserButton, UsersTable } from './users';
import { SonarCardTabs, ViewArea } from '@ui/general';
const tabs = [
    {
        children: React.createElement(UsersTable, null),
        extra: React.createElement(AddNewUserButton, null),
        key: 'users',
        label: COPY_SPECIFIC.AROVY_USERS
    },
    {
        children: React.createElement(StakeholdersTable, null),
        extra: React.createElement(AddNewStakeholderButton, null),
        key: 'stakeholders',
        label: COPY_SPECIFIC.STAKEHOLDERS
    }
];
export const TeamView = () => React.createElement(ViewArea, { fullWidth: true, id: 'team-view' },
    React.createElement(SonarCardTabs, { items: tabs, title: COPY_SPECIFIC.TEAM }));
